import { QuestionStep } from '../QuestionStep';
import { cn } from '@/lib/utils';
import { STEPS, type QuestionnaireAnswers } from '../questions';
import { usePublicSettings } from '@/hooks/usePublicSettings';

interface PagesStepProps {
  answers: QuestionnaireAnswers;
  onChange: (next: Partial<QuestionnaireAnswers>) => void;
}

export function PagesStep({ answers, onChange }: PagesStepProps) {
  const step = STEPS.find((s) => s.id === 'pages')!;
  const value = answers.page_count ?? 0;
  const MAX_PAGES = usePublicSettings().maxSketchesPerProject;
  const choices = Array.from({ length: MAX_PAGES }, (_, i) => i + 1);

  return (
    <QuestionStep step={step}>
      <div className="flex flex-wrap gap-3">
        {choices.map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => onChange({ page_count: n })}
            className={cn(
              'flex h-20 w-20 flex-col items-center justify-center rounded-sm border bg-paper transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ochre',
              value === n
                ? 'border-ink shadow-[inset_0_0_0_1px_hsl(var(--ink))]'
                : 'border-ink/15 hover:border-ink/40',
            )}
            aria-pressed={value === n}
          >
            <span className="font-serif text-3xl text-ink">{n}</span>
            <span className="font-mono text-[10px] uppercase tracking-wider text-graphite">
              {n === 1 ? 'page' : 'pages'}
            </span>
          </button>
        ))}
      </div>
      <p className="mt-6 max-w-xl font-mono text-[11px] text-graphite leading-relaxed">
        <span className="text-ochre">¶</span>&nbsp;&nbsp;AURA caps at {MAX_PAGES} pages. You will upload one lo-fi sketch per page on the next screen.
      </p>
    </QuestionStep>
  );
}
